import { NgModule } from "@angular/core";
import { WorkflowFormModule } from "../form/workflow-form.module";
import { PimWorkflowListModule } from "./list/pim-workflow-list.module";
import { PimWorkflowRoutingModule } from "./pim-workflow.routing";

@NgModule({
    imports: [PimWorkflowRoutingModule, PimWorkflowListModule, WorkflowFormModule],
})
export class PimWorkflowModule {}
